'use strict'

mapTemplate = require '../../dynamic_map.html.mustache'

module.exports = Backbone.View.extend
  render: (map) ->
    @$el.html mapTemplate.render {map}